import { useState, useRef, useCallback } from 'react';
import { Paper, InputBase, Divider, FormControl } from '@mui/material';
import { makeStyles } from '@mui/styles';
import debounce from 'lodash.debounce';

const useStyles = makeStyles((theme) => ({
  paper: {
    p: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
  },
}));

interface SearchBarProp {
  value?: string | number;
  onSearch: (textSearch: any) => void;
  allowSearchAll?: boolean;
}

const FilterOptions = (props: SearchBarProp) => {
  const classes = useStyles();
  const [value, setValue] = useState('');
  const formRef = useRef<any>(null);

  const handleDebounceFn = (inputValue) => {
    props.onSearch(inputValue);
  };

  const debounceFn = useCallback(debounce(handleDebounceFn, 500), []);
  const handleChange = (event) => {
    setValue(event.target.value);
    debounceFn(event.target.value);
  };

  return (
    <Paper
      component='form'
      className={classes.paper}
      ref={formRef}
      //  onSubmit={handleSubmit}
      style={{ marginBottom: 10 }}
    >
      <FormControl variant="standard" sx={{ m: 1, width: '100%' }} size='small'>
        <InputBase id='searchInput' sx={{ ml: 1, flex: 1 }} placeholder='Fillter...' value={value ?? ''} onChange={handleChange} />
      </FormControl>
      <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
    </Paper>
  );
};

export default FilterOptions;
